import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams } from "react-router-dom"
import Alert from 'react-bootstrap/Alert'
import { FaBars } from 'react-icons/fa'
import { Stepper } from 'react-form-stepper'
import { apiURL, sitePath, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import ModelViewer2d from "components/ModelViewer2d"
import ModelViewer3d from "components/ModelViewer3d"
import NewRecordNavigation from 'components/NewRecordNavigation'
import MarkerTable from 'components/MarkerTable'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'
import { storeCurrentRecord, getCurrentRecord } from 'utils/RecordManager'

const recordCategories = [
    { value: 'negativeFeatures', label: 'Negative features' },
    { value: 'loadBearing', label: 'Load bearing elements' },
    { value: 'nonLoadBearing', label: 'Non-load bearing elements' },
    { value: 'frameAndRoof', label: 'Frame and roof substructure' },
    { value: 'roof', label: 'Roof' },
    { value: 'doorsAndWindows', label: 'Doors and windows' },
]

const steps = recordCategories.concat({label: 'Validate and submit'})

const RecordNew = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [currentBuilding, setCurrentBuilding] = useState({})
    const [currentStep, setCurrentStep] = useState(0)
    const [currentRecord, setCurrentRecord] = useState({markers: []})
    const [errorMessage, setErrorMessage] = useState('')
    
    const navigate = useNavigate()
    const { buildingId, recordId } = useParams()

    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getBuilding(buildingId)
            if (recordId) {
                await getRecord(recordId)
            }
        }
        start()
    }, [])

    const getBuilding = async (id) => {
        const response = await axios.get(`${apiURL}/get-building/${id}`)

        if (!response.data.success) {
            setErrorMessage(response.data.error || response.data)
            return
        }

        setCurrentBuilding(response.data.item)
    }

    const getRecord = async (id) => {
        const response = await axios.get(`${apiURL}/get-record/${id}`)

        if (!response.data.success) {
            setErrorMessage(response.data.error || response.data)
            return
        }

        const record = response.data.item
        storeCurrentRecord(record)
        record.markers = JSON.parse(record.markers)
        setCurrentRecord(record)
    }

    const setRecordData = () => {
        // if (currentBuilding.id) {
        //     return
        // }
        // const building = data.find(x => x.id === parseInt(id))
        // setCurrentBuilding(building ? building : {})
        setCurrentRecord(getCurrentRecord())
    }

    const addMarker = (marker) => {
        let record = {...currentRecord}
        record.markers.push(marker)

        setCurrentRecord(record)
        storeCurrentRecord(record)
    }

    const goToTop = () => {
        document.querySelector("main").scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const submit = async () => {
        const record = {...currentRecord}
        record.buildingId = buildingId
        record.createdBy = currentUser.email

        const response = record.id
            ? await axios.put(`${apiURL}/update-record/${record.id}`, record)
            : await axios.post(`${apiURL}/create-record`, record)
        
        if (!response.data.success) {
            setErrorMessage(response.data.error || response.data)
            return
        }
        
        navigate(`/records`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="records" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Buildings', '/buildings'], [currentBuilding.name, `/buildings/${currentBuilding.id}`], ['New Record']]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>New Record</h1>
                    </div>
                </header>
                {errorMessage && 
                    <Alert key='submitError' variant='danger'>
                        {errorMessage}
                    </Alert>
                }
                <NewRecordNavigation
                    steps={steps}
                    currentStep={currentStep}
                    showLabels={false}
                    onChangeStep={setCurrentStep}
                    onSubmit={submit}
                />
                <Stepper
                    steps={steps}
                    activeStep={currentStep}
                    className="mb-4"
                />
                {currentBuilding.modelType === '3d' &&
                    <ModelViewer3d
                        modelFileName={currentBuilding.modelFile}
                        record={currentRecord}
                        category={steps[currentStep]}
                        allowNewMarkers={currentStep !== steps.length - 1}
                        onAddMarker={addMarker}
                    />
                }
                {currentBuilding.modelType === '2d' &&
                    <ModelViewer2d
                        modelFileName={currentBuilding.modelFile}
                        record={currentRecord}
                        category={steps[currentStep]}
                        allowNewMarkers={currentStep !== steps.length - 1}
                        onAddMarker={addMarker}
                    />
                }
                <NewRecordNavigation
                    steps={steps}
                    currentStep={currentStep}
                    recordId={currentRecord.id}
                    showLabels={true}
                    onChangeStep={(step) => {
                        setCurrentStep(step)
                        goToTop()
                    }}
                    onSubmit={submit}
                />
                <h5 className="mt-5">Marks in this record</h5>
                <MarkerTable
                    markers={currentRecord.markers}
                />
                <h5 className="mt-5">Recent marks found in other records</h5>
                Not implemented yet.
                <Footer user={currentUser} />
                
            </main>
        </>
    )
}

export default RecordNew